import httpClient from '@/api/httpClient';

const loadTranslations = language => {
    return httpClient.get('i18n/' + language);
};

export default {
    loadTranslations,
};
